import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import DanhSachNhanVienApi from "service/danhSachNhanVienApi";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import Select from "react-select";
import { pushNotification } from "utils/notifications";

export const ModalDuyetTatToan = (props) => {
  const [loading, setLoading] = useState(true);
  const [isDisable, setIsDisable] = useState(false);
  const [dataDanhSach, setDataDanhSach] = useState([]);
  const [showEdit, setShowEdit] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [deleteItem, setDeleteItem] = useState(null);
  const [nhanVien, setNhanVien] = useState([]);
  const [nhanVienSelect, setNhanVienSelect] = useState([]);
  const [duyetTatToanSelect, setDuyetTatToanSelect] = useState([]);
  const [userDuyetTatToan, setUserDuyetTatToan] = useState([]);

  const DanhSachCapDuyet = () => {
    console.log("responseresponse88");
    DanhSachNhanVienApi.danhsachcapduyettattoan().then((response) => {
      if (response.status == "200") {
        console.log("responseresponse", response.data.List);
        setDataDanhSach(response.data.List);
        setNhanVien(response.data.List2);
        setUserDuyetTatToan(response.data.List3);
      }
    });
  };

  // 📝 Mở popup sửa
  const handleEdit = (item) => {
    console.log("nhanVien", nhanVien);
    setEditingItem(item);
    setDuyetTatToanSelect(item.DuyetTatToanID);
    const listNVDuyet = userDuyetTatToan
      .filter((x) => x.DuyetTatToanID === item.DuyetTatToanID)
      .map((x) => {
        const nv = nhanVien.find((n) => n.value === x.UserName);
        return {
          value: x.UserName,
          label: nv ? `${nv.label}` : "",
        };
      });

    setNhanVienSelect(listNVDuyet);
    console.log("setNhanVienSelect", listNVDuyet);
    setShowEdit(true);
    setShowAdd(false);
  };

  // 📝 Mở popup sửa
  const handleAdd = () => {
    setShowAdd(true);
    setShowEdit(false);
    const item = {
      DuyetTatToanID: 0,
      TenCapDuyet: "",
      listNhanVien: "",
    };
    setNhanVienSelect([]);
    setDuyetTatToanSelect(0);
    setEditingItem(item);
  };

  const handleDelete = (item) => {
    setShowDelete(true);
    setDeleteItem(item);
  };

  useEffect(() => {
    if (props.show && loading) {
      DanhSachCapDuyet();
      setLoading(false);
    }
  });

  // popup xóa
  const [showDelete, setShowDelete] = useState(false);

  // 🔴 Xóa dòng (sau khi xác nhận)
  const confirmDelete = () => {
    console.log("✅ List item9967867", deleteItem);
    const item = {
      DuyetTatToanID: deleteItem.DuyetTatToanID,
      TenCapDuyet: deleteItem.TenCapDuyet,
      listNhanVien: "",
    };
    DanhSachNhanVienApi.deleteChucVU(item).then((response) => {
      if (response.data.Error == 0) {
        pushNotification(response.data.Message, "success", "TOP_CENTER", 1000);
        DanhSachCapDuyet();
      } else
        pushNotification(response.data.Message, "error", "TOP_CENTER", 1000);
    });
  };

  // ✅ Lưu cập nhật sửa
  const handleSaveEdit = () => {
    console.log("✅ List item9967867");
    const listUserName = nhanVienSelect.map((x) => x.value).join(";");

    const item = {
      DuyetTatToanID: duyetTatToanSelect,
      TenCapDuyet: editingItem.TenCapDuyet,
      listNhanVien: listUserName,
    };
    console.log("✅ List item:", item);
    DanhSachNhanVienApi.addOrEditNhanVienDuyet(item).then((response) => {
      if (response.data.Error == 0) {
        pushNotification(response.data.Message, "success", "TOP_CENTER", 1000);
        DanhSachCapDuyet();
      } else
        pushNotification(response.data.Message, "error", "TOP_CENTER", 1000);
    });
  };

  const deleteChucVu = () => {
    // console.log("✅ List item9967867");
    // const listUserName = nhanVienSelect.map((x) => x.value).join(";");
    // const item = {
    //   DuyetTatToanID: duyetTatToanSelect,
    //   TenCapDuyet: editingItem.TenCapDuyet,
    //   listNhanVien: listUserName,
    // };
    // console.log("✅ List item:", item);
    // DanhSachNhanVienApi.addOrEditNhanVienDuyet(item).then((response) => {
    //   if (response.data.Error == 0) {
    //     pushNotification(response.data.Message, "success", "TOP_CENTER", 1000);
    //     DanhSachCapDuyet();
    //   } else
    //     pushNotification(response.data.Message, "error", "TOP_CENTER", 1000);
    // });
  };

  const closePopup = (index) => {
    setShowAdd(false);
    setShowEdit(false);
  };

  // 💾 Lưu thứ tự mới xuống server; nếu lỗi thì nạp lại thứ tự cũ
  const capNhatThuTu = (list) => {
    const payload = list.map((x) => ({
      DuyetTatToanID: x.DuyetTatToanID,
      ThuTu: x.ThuTu,
    }));
    DanhSachNhanVienApi.capNhatThuTuCapDuyet(payload).then((response) => {
      if (response.data.Error != 0) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 1000);
        DanhSachCapDuyet(); // rollback UI: nạp lại thứ tự từ server
      }
    });
  };

  const moveUp = (index) => {
    if (index === 0) return; // dòng đầu tiên không di chuyển được
    const newList = [...dataDanhSach];
    [newList[index - 1], newList[index]] = [newList[index], newList[index - 1]];
    // cập nhật lại thứ tự
    const updated = newList.map((x, i) => ({ ...x, ThuTu: i + 1 }));
    setDataDanhSach(updated);
    capNhatThuTu(updated);
  };

  // 🔽 Di chuyển xuống
  const moveDown = (index) => {
    if (index === dataDanhSach.length - 1) return;
    const newList = [...dataDanhSach];
    [newList[index], newList[index + 1]] = [newList[index + 1], newList[index]];
    const updated = newList.map((x, i) => ({ ...x, ThuTu: i + 1 }));
    setDataDanhSach(updated);
    capNhatThuTu(updated);
  };

  const renderTableRows = () => {
    console.log("dataDanhSach", dataDanhSach);
    return dataDanhSach.map((item, index) => (
      <div class="custom-table-row active">
        <div class="custom-table-cell flex-basis-15 flex-basis-15-sm">
          <span class="mobile-column-name">Thứ tự duyệt</span>
          <div class="center-wrapper">
            <span class="text-left">{item.ThuTu}&nbsp;&nbsp;</span>
            <span>
              {index > 0 && (
                <a href={() => false} onClick={() => moveUp(index)}>
                  <PopoversBootrap
                    contentText="Lên trên"
                    trigger={["hover", "focus"]}
                    placement={"top"}
                  >
                    <i className="mdi mdi-arrow-up-circle"></i>
                  </PopoversBootrap>
                </a>
              )}
              &nbsp;&nbsp;
              {/* 🔽 Xuống */}
              {index < dataDanhSach.length - 1 && (
                <a href={() => false} onClick={() => moveDown(index)}>
                  <PopoversBootrap
                    contentText="Xuống dưới"
                    trigger={["hover", "focus"]}
                    placement={"top"}
                  >
                    <i className="mdi mdi-arrow-down-circle"></i>
                  </PopoversBootrap>
                </a>
              )}
            </span>
          </div>
        </div>

        <div class="custom-table-cell flex-basis-15 flex-basis-15-sm">
          <span class="mobile-column-name">Tên cấp duyệt</span>
          <div class="center-wrapper">
            <p class="text-left">{item.TenCapDuyet}</p>
          </div>
        </div>

        <div class="custom-table-cell flex-basis-50 flex-basis-50-sm">
          <span class="mobile-column-name">Tài khoản duyệt</span>
          <div class="center-wrapper">
            <p class="text-left">{item.NhanVien}</p>
          </div>
        </div>

        <div class="custom-table-cell flex-basis-20 flex-basis-20-sm  action-cell">
          <div class="center-wrapper">
            <div class="iconTableMormanCenter">
              <a href={() => false} onClick={(e) => handleEdit(item)}>
                <PopoversBootrap
                  contentText="Sửa"
                  trigger={["hover", "focus"]}
                  placement={"top"}
                >
                  <img src="/app-assets/images/icon-button-edit-v2.png" />
                </PopoversBootrap>
              </a>

              <a
                href={() => false}
                onClick={() => {
                  handleDelete(item);
                }}
              >
                <PopoversBootrap
                  contentText="Xoá"
                  trigger={["hover", "focus"]}
                  placement={"top"}
                >
                  <img src="/app-assets/images/icon-button-xoa-v2.png" />
                </PopoversBootrap>
              </a>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  return (
    <>
      <Modal
        {...props}
        size="modal-new-size modal-new-size"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left popup-detail"
      >
        <Modal.Header>
          <h4 class="modal-title color7-bold" id="myModalLabel16">
            <span class="btn-icon-right">
              <img src="/app-assets/images/icon-donglai.png" alt="" />
            </span>
            &nbsp; {showEdit ? "Cập nhật" : "Thêm mới"}
          </h4>
          <button
            type="button"
            className="close-popup-new"
            onClick={props.onHide}
          >
            <i class="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body>
          <form class="form tat-toan form-horizontal ">
            <div class="form-body">
              <div class="card collapse-icon accordion-icon-rotate">
                <div
                  id="headingCollapse253"
                  class="card-header border-info"
                  href="#collapse253"
                  aria-expanded="true"
                  aria-controls="collapse253"
                >
                  <a href={() => false} class="card-title lead info collapsed">
                    <h3>Danh sách cấp duyệt tất toán</h3>
                  </a>
                  <div className="card border-light mb-1">
                    <div className="card-body card-body-v2">
                      <div className="row col-sm-12 col-md-12">
                        <button
                          type="button"
                          class="btn btn-chuc-nang-v2"
                          onClick={handleAdd}
                        >
                          <i class="mdi mdi-plus"></i>Thêm mới cấp duyệt
                        </button>
                      </div>
                      <br />
                      <div class="Left808x200 Table-main-new">
                        <div class="table-mobile ">
                          <div class="custom-table-wrapper">
                            <div class="table-headers">
                              <div class="custom-table-header flex-basis-15 flex-basis-10-sm">
                                <p class="text-left">Thứ tự duyệt</p>
                              </div>
                              <div class="custom-table-header flex-basis-15 flex-basis-15-sm">
                                <p class="text-left">Tên cấp duyệt</p>
                              </div>
                              <div class="custom-table-header flex-basis-50 flex-basis-10-sm">
                                <p class="text-left">Tài khoản duyệt</p>
                              </div>
                              <div class="custom-table-header flex-basis-20 flex-basis-10-sm">
                                <p class="text-center">Thao tác</p>
                              </div>
                            </div>

                            <div class="custom-table-body">
                              {renderTableRows()}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id="collapse253"
                  aria-labelledby="headingCollapse253"
                  class="card-collapse collapse show"
                  aria-expanded="true"
                ></div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="modal-footer button-popup-new-size">
          {/* <button
            className="btn btn-new-main btn-checknew"
            // onClick={addOrEdit}
            disabled={isDisable}
          >
            <span>
              <i class="mdi mdi-check"></i>
            </span>
            &nbsp; {showEdit ? "Cập nhật" : "Thêm mới"}
            &nbsp;
          </button>
          &nbsp; */}
          <a
            className="btn btn-new-main btn-closenew"
            data-dismiss="modal"
            href={() => false}
            onClick={props.onHide}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-close"></i>
            </span>{" "}
            Đóng
          </a>
        </Modal.Footer>
      </Modal>
      {/* === POPUP SỬA === */}

      <Modal
        show={showEdit || showAdd}
        onHide={() => setShowEdit(false)}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left popup-detail"
      >
        <Modal.Header>
          <h4 class="modal-title color7-bold" id="myModalLabel16">
            <span class="btn-icon-right">
              <img src="/app-assets/images/icon-donglai.png" alt="" />
            </span>
            &nbsp; {showEdit ? "Cập nhật" : "Thêm mới"}
          </h4>
          <button
            type="button"
            className="close-popup-new"
            onClick={closePopup}
          >
            <i class="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body>
          {editingItem && (
            <>
              <div className="form-group">
                <label>Tên cấp duyệt</label>
                <input
                  type="text"
                  className="form-control"
                  value={editingItem.TenCapDuyet}
                  onChange={(e) =>
                    setEditingItem({
                      ...editingItem,
                      TenCapDuyet: e.target.value,
                    })
                  }
                />
              </div>
              <div className="form-group">
                <Select
                  defaultValue={nhanVienSelect}
                  isMulti
                  name="colors"
                  options={nhanVien}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  onChange={(selected) => setNhanVienSelect(selected || [])}
                />
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-new-main btn-checknew"
            onClick={handleSaveEdit}
            disabled={isDisable}
          >
            <span>
              <i class="mdi mdi-check"></i>
            </span>
            &nbsp; {showEdit ? "Cập nhật" : "Thêm mới"}
          </button>
          &nbsp;
          <a
            className="btn btn-new-main btn-closenew"
            data-dismiss="modal"
            href={() => false}
            onClick={closePopup}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-close"></i>
            </span>{" "}
            Đóng
          </a>
        </Modal.Footer>
      </Modal>

      {/* === POPUP XÓA === */}
      <Modal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left popup-detail"
      >
        <Modal.Header>
          <h4 class="modal-title color7-bold" id="myModalLabel16">
            <span class="btn-icon-right">
              <img src="/app-assets/images/icon-donglai.png" alt="" />
            </span>
            Xác nhận xóa
          </h4>
          <button
            type="button"
            className="close-popup-new"
            onClick={() => setShowDelete(false)}
          >
            <i class="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body>Bạn có chắc muốn xóa tài khoản duyệt này không?</Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-new-main btn-checknew"
            onClick={confirmDelete}
            disabled={isDisable}
          >
            <span>
              <i class="mdi mdi-check"></i>
            </span>
            Xóa
          </button>
          &nbsp;
          <a
            className="btn btn-new-main btn-closenew"
            data-dismiss="modal"
            href={() => false}
            onClick={props.onHide}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-close"></i>
            </span>{" "}
            Đóng
          </a>
        </Modal.Footer>
      </Modal>
    </>
  );
};
